import { BreakpointObserver } from '@angular/cdk/layout';
import { inject, Injectable } from '@angular/core';
import { CustomBreakpoints } from '@shared/constants/custom-breakpoints';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
    providedIn: 'root',
})
export class BreakpointService {
    private breakpoint = '';

    breakpointObserver = inject(BreakpointObserver);
    private breakpointSubject: BehaviorSubject<string> = new BehaviorSubject<string>('');
    breakpoint$: Observable<string> = this.breakpointSubject.asObservable();
    set(): void {
        this.breakpointObserver.observe(Object.values(CustomBreakpoints)).subscribe((result) => {
            const breakpointString = Object.keys(CustomBreakpoints).find((key) => result.breakpoints[CustomBreakpoints[key as keyof typeof CustomBreakpoints]]);
            this.breakpoint = breakpointString || '';
            this.breakpointSubject.next(this.breakpoint);
        });
    }

    minorEqual(targetBreakpoint: string): boolean {
        const breakpointsArray = Object.keys(CustomBreakpoints);

        const currentIndex = breakpointsArray.indexOf(this.breakpoint);
        const targetIndex = breakpointsArray.indexOf(targetBreakpoint);

        if (currentIndex === -1 || targetIndex === -1) {
            return true;
        }

        return currentIndex <= targetIndex;
    }

    majorEqual(targetBreakpoint: string): boolean {
        const breakpointsArray = Object.keys(CustomBreakpoints);

        const currentIndex = breakpointsArray.indexOf(this.breakpoint);
        const targetIndex = breakpointsArray.indexOf(targetBreakpoint);
        if (currentIndex === -1 || targetIndex === -1) {
            return false;
        }

        return currentIndex >= targetIndex;
    }
}
